import { getConfig } from './config';
import type { GovernPriority } from 'owa-client-types/lib/GovernPriority';

let callbacks: (() => void)[] = [];
const blockedNames: string[] = [];
let unblocked = false;
export function runAfterInitialRender(
    callback: () => Promise<void>,
    name: string,
    governPriority: GovernPriority | undefined,
    addToFront?: boolean
): void {
    const cb =
        governPriority != undefined
            ? () => {
                  // we check for govern here because some modules are loaded early enough that govern is not yet available
                  const { govern } = getConfig();
                  return govern
                      ? govern({
                            task: callback,
                            priority: governPriority,
                            name: `LazyModuleGovern${name ?? 'Unknown'}`,
                            // Generated by Copilot. Please update with the correct owners.
                            ownership: ['jarmit@microsoft.com'],
                        })
                      : callback();
              }
            : callback;
    if (unblocked) {
        cb();
    } else {
        blockedNames.push(name);
        if (addToFront) {
            callbacks.unshift(cb);
        } else {
            callbacks.push(cb);
        }
    }
}

export function unblockLazyLoadCallbacks(): void {
    unblocked = true;
    for (var ii = 0; ii < callbacks.length; ii++) {
        callbacks[ii]();
    }
    callbacks = [];
}

export function blockLazyLoadCallbacks(): void {
    unblocked = false;
}

export function getBlockedLazyLoadNames(): string[] {
    return blockedNames;
}
